"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrowserOnly = void 0;
var _useIsBrowser = require("../hooks/useIsBrowser");
/**
 * Checks if component has mounted and triggers a rerender so SSR UI's can hydrate properly
 * @link https://www.joshwcomeau.com/react/the-perils-of-rehydration/#abstractions
 * Does not render component on the server
 */
const BrowserOnly = ({
  children
}) => {
  const componentShouldMount = (0, _useIsBrowser.useIsBrowser)();
  return componentShouldMount ? children : null;
};
exports.BrowserOnly = BrowserOnly;